<template>
    <v-container fluid>
        <v-card>
            <v-toolbar color="secondary" flat dense>
                <v-toolbar-title>Non Adjusted Products </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <v-row>
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                        hide-details></v-text-field>
                </v-row>
                <v-row class="text--primary subtitle-2">
                    <v-col cols="12">
                        <v-data-table :items-per-page="2000" loading-text="Loading Data......" :headers="headers"
                            :items="inventory" :search="search" :mobile-breakpoint="0">
                        </v-data-table>
                    </v-col>
                </v-row>

            </v-card-text>
            <!-- snackbar -->

            <snackbar ref="snackbar"></snackbar>
        </v-card>
    </v-container>
</template>


<script>
export default {
    computed: {
        activeStore() {
            return localStorage.getItem("store_id");
        },
    },
    data() {
        return {
            selectedStoreName: "",
            showPrinterDiv: false,
            DefaultDistributorCustomer: 0,
            smsRef: "",
            select: "",
            isLoading: false,
            search: null,
            searchStock: null,
            pageItems: 500,
            loader: false,
            editItem: {},
            damagedItem: {},
            transferItem: {},
            store: null,
            queryStore: null,
            stores: [],
            users: [],
            date: null,
            dialog: false,
            damageDialog: false,
            transferDialog: false,
            searchProducts: null,
            todayDate: new Date().toISOString().substr(0, 10),
            products: [],
            headers: [
                { text: "Product Name", value: "ProductName" },
            ],
            fields: {
                ItemCode: "ItemCode",
                Product: "Name",
                AvailableQty: "AvailableQty",
            },
            inventory: [],
        };
    },
    watch: {

    },
    methods: {
        queryData() {
            let data = {};
            data.StartDate = '2025-11-05';
            data.EndDate = '2025-11-09';
            data.StoreId = parseInt(this.activeStore);
            const self = this;
            self.loader = true;
            var url = `/check-non-adjusted-stock`;
            this.$store
                .dispatch("post", { url, data })
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.loader = false;
                        console.log(res.ResponseData, " non adjusted ");
                        if (res.ResponseData != null) {
                            self.inventory = res.ResponseData;
                        }

                        if (res.ResponseData == null) {
                            self.inventory = [];
                        }

                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
    },
    created() {
        Promise.all([this.queryData()]);
    },
};
</script>

<style lang="scss" scoped></style>